import cn from 'classnames';
import { ButtonWithIcon } from '@ui/button';
import { IWarehouseBagTemplateProps } from '..';
import { SimpleBunkerIcon } from '@@/equipments/icons/bunlers.icons';
import { UiIcon } from '@/modules/ui/components/ui-icon';
import styles from './styles.module.css';
import { getClassInfo } from '../healpers/getClassInfo';

export function WarehouseBagBunkerTemplate(props: IWarehouseBagTemplateProps) {
  const {
    className,
    image,
    cultureName,
    sleeveId = '',
    attention = false,
    borderColor = 'transparent',
    backgroundColor = 'transparent',
    params = [],
    filled = '',
    actions = null,
    mixed = false,
    values,
    resevedWeight,
    ...rest
  } = props;
  const rootClass = cn(className, styles.bag);
  return (
    <div className={rootClass} {...rest}>
      <svg
        width="391"
        height="180"
        viewBox="0 0 304 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M1.40459 126.736L1.40466 126.736C28.6432 71.2088 70.6129 28.2785 112.779 9.02848C137.696 -2.34285 166.312 -2.34281 191.221 9.02848C233.387 28.2785 275.349 71.2088 302.595 126.736L303.044 126.516L302.595 126.736C305.431 132.513 301.254 139.249 294.811 139.249H152.004H9.18919C2.74558 139.249 -1.4314 132.513 1.40459 126.736Z"
          fill={backgroundColor}
          stroke={borderColor}
        />
      </svg>

      <div className={styles.data}>
        {mixed && <UiIcon className={styles.mixed} icon={<SimpleBunkerIcon />} />}
        {resevedWeight ? (
          <div className={styles.addedToOffer}>участвует в сделке</div>
        ) : (
          ''
        )}

        <div className={styles.top}>
          <ButtonWithIcon
            icon="Attention"
            className={cn([styles.attention, { [styles.hidden]: !attention }])}
          />
          {image}
          <div className={styles.actions}>{actions}</div>
        </div>
        <div className={styles.header}>
          <span className={styles.bunkerId}>{sleeveId}</span>
          <span className={styles.title}>
            {cultureName} {getClassInfo(values)}
          </span>
          <div className={styles.params}>{params}</div>
          <span className={styles.filled}>{filled}</span>
        </div>
      </div>
    </div>
  );
}
